const getEnvVar = (key: string, defaultValue?: string): string => {
  const value = import.meta.env[key] ?? defaultValue
  if (value === undefined) {
    throw new Error(`Missing environment variable: ${key}`)
  }
  return value
}

export const env = {
  apiBaseUrl: getEnvVar('VITE_API_BASE_URL', 'http://localhost:5000/api/v1'),
  mapboxToken: getEnvVar('VITE_MAPBOX_TOKEN', ''),
  nodeEnv: getEnvVar('MODE', 'development'),
  isDev: import.meta.env.DEV,
  isProd: import.meta.env.PROD,
  useDriverMocks: getEnvVar('VITE_USE_DRIVER_MOCKS', 'false') === 'true',
} as const

export type Env = typeof env
